import { IApplicationState } from '../../types/redux';

export const selectOpenedShareCollection = (state: IApplicationState) => {
  const shareCollection = state.shareCollection;

  if (!shareCollection.openedId) {
    return null;
  }

  const { shares, openedId } = shareCollection;

  return shares.find(({ id }) => id === openedId) || null;
};
